import React, { useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { doSignInWithEmailAndPassword, doSignInWithGoogle } from "../../firebase/auth";
import { useAuth } from "../../contexts/authContext";
import { addUserToDictionary } from "../../data/AsyncFunctions/getAddUserAccount";

function Login() {
  const { userLoggedIn } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSigningIn, setIsSigningIn] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    if (isSigningIn) return;

    setIsSigningIn(true);
    setErrorMessage("");

    try {
      const userCredential = await doSignInWithEmailAndPassword(email, password);
      await addUserToDictionary(userCredential.user);
    } catch (err) {
      setErrorMessage(err.message || "Failed to sign in");
    } finally {
      setIsSigningIn(false);
    }
  };

  const onGoogleSignIn = async () => {
    if (isSigningIn) return;

    setIsSigningIn(true);
    setErrorMessage("");

    try {
      const userCredential = await doSignInWithGoogle();
      await addUserToDictionary(userCredential.user);
    } catch (err) {
      setErrorMessage(err.message || "Failed to sign in with Google");
    } finally {
      setIsSigningIn(false);
    }
  };

  if (userLoggedIn) {
    return <Navigate to="/fridge" replace />;
  }

  return (
    <div className="flex justify-center mt-20 px-4">
      <div className="w-full max-w-md">
        <h1 className="text-3xl font-bold text-center mb-2">
          Sign In
        </h1>
        <p className="text-center text-gray-600 mb-8">
          Enter your email and password to sign in
        </p>

        <form onSubmit={onSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <input
              type="email"
              className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Password
            </label>
            <input
              type="password"
              className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {errorMessage && (
            <p className="text-sm text-red-600 font-medium">
              {errorMessage}
            </p>
          )}

          <button
            type="submit"
            disabled={isSigningIn}
            className="w-full rounded-md bg-indigo-600 px-4 py-2 text-white font-medium hover:bg-indigo-700 transition disabled:opacity-50"
          >
            {isSigningIn ? "Signing In..." : "Sign In"}
          </button>
        </form>

        <div className="mt-6">
          <button
            onClick={onGoogleSignIn}
            disabled={isSigningIn}
            className="w-full rounded-md border border-gray-300 px-4 py-2 font-medium hover:bg-gray-50 transition disabled:opacity-50"
          >
            {isSigningIn ? "Signing In..." : "Sign in with Google"}
          </button>
        </div>

        <p className="text-center text-sm text-gray-600 mt-6">
          Not registered?
          <Link to="/sign-up" className="ml-1 text-indigo-600 font-medium">
            Create account
          </Link>
        </p>
      </div>
    </div>
  );
}

export default Login;